
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/multgame/login",
      function () {
        return require("private-next-pages/games/multgame/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/multgame/login"])
      });
    }
  